import { render, staticRenderFns } from "./AddReminderWorkflow.vue?vue&type=template&id=25d0938a&scoped=true&"
import script from "./AddReminderWorkflow.vue?vue&type=script&lang=js&"
export * from "./AddReminderWorkflow.vue?vue&type=script&lang=js&"
import style0 from "./AddReminderWorkflow.vue?vue&type=style&index=0&id=25d0938a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25d0938a",
  null
  
)

component.options.__file = "AddReminderWorkflow.vue"
export default component.exports